/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAdminFunktionDto } from '../../models/lexplus-admin-funktion-dto';

export interface FunktionenControllerFindByKundeV1$Params {
  kundeId: number;
}

export function funktionenControllerFindByKundeV1(http: HttpClient, rootUrl: string, params: FunktionenControllerFindByKundeV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusAdminFunktionDto>>> {
  const rb = new RequestBuilder(rootUrl, funktionenControllerFindByKundeV1.PATH, 'get');
  if (params) {
    rb.query('kundeId', params.kundeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusAdminFunktionDto>>;
    })
  );
}

funktionenControllerFindByKundeV1.PATH = '/v1/funktionen';
